<app-patients-intro></app-patients-intro>
<app-patients-plan-pricing></app-patients-plan-pricing>
<app-patients-faq></app-patients-faq>
<!-- <app-patients-coming-soon></app-patients-coming-soon> -->
<app-patients-application-form></app-patients-application-form>